import { combineReducers, createStore, applyMiddleware } from 'redux'
import thunk from "redux-thunk";
import CommonReducer from './common/redux/reducers';

const reducer = combineReducers({
  common: CommonReducer,
})

export default createStore(reducer, applyMiddleware(thunk));
